import React from 'react';
import './AdminEvents.css';
import EventsOverviewPage from './EventsOverviewPage/EventsOverviewPage';
import CreateEvent from './CreateEvent/CreateEvent';
import { AnimatePresence, motion } from 'framer-motion';
import { Route, withRouter } from 'react-router-dom';
import WebsiteContent from '../AdminEvents/WebsiteContent/WebsiteContent';
import AddEventHeadline from './WebsiteContent/AddEventHeadline';

function AdminEvents(props) {
	return (
		<motion.div className='adminEventsPageWrapper'>
			<AnimatePresence exitBeforeEnter>
				{/* <Route path={`${props.match.path}`} exact >
					<EventsOverviewPage />
				</Route> */}
				<Route path={`${props.match.path}/create`}>
					<CreateEvent />
				</Route>
				{/* <Route path={`${props.match.path}/website-content`}>
					<WebsiteContent />
				</Route>
				<Route path={`${props.match.path}/event-headline`}>
					<AddEventHeadline />
				</Route>
				<Route path={`${props.match.path}/event-inclusion`}>
					<AddEventHeadline />
				</Route> */}
			</AnimatePresence>
		</motion.div>
	);
}

export default withRouter(AdminEvents);
